import React, { useState, useEffect } from "react";
import profile_picture from "../asset/profile.jpg";
import avatar from "../asset/avatar_1.jpeg";
import UserProfileFlip from "./UserProfileFlip";
import DownloadButton from "./DownloadButton";

const fullText = "who is passionate about bringing ideas to life.";

function About() {
  const [text, setText] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (index < fullText.length) {
      const timer = setTimeout(() => {
        setText((prev) => prev + fullText[index]);
        setIndex((prev) => prev + 1);
      }, 40);
      return () => clearTimeout(timer);
    }
  }, [index]);

  return (
    <section id="about" className="min-h-screen flex items-center bg-hero-gradient">
      <div className="mx-auto max-w-6xl w-full px-6 py-20 flex flex-col md:flex-row items-center gap-12">
        <div className="flex-1 flex flex-col items-center md:items-start text-center md:text-left">
          <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full px-4 py-1.5 mb-6">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
            <span className="text-emerald-400 text-sm font-medium">Available for work</span>
          </div>

          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Hi there{" "}
            <span className="wave inline-block" role="img" aria-label="waving hand">
              👋
            </span>
          </h1>

          <h2 className="text-3xl sm:text-4xl font-bold mb-4">
            <span className="text-white">I'm a </span>
            <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
              Full Stack Engineer
            </span>
          </h2>

          <p className="text-gray-400 text-lg mb-4 max-w-lg leading-relaxed">
            <span>{text}</span>
            <span className="animate-pulse text-emerald-400">|</span>
          </p>

          <p className="text-gray-500 text-base mb-8 max-w-lg leading-relaxed">
            Based in Lagos, Nigeria. I specialise in building full-stack products — from
            REST APIs and microservices to polished React frontends. I've shipped fintech,
            marketplace, and identity-verification platforms used across Nigeria and Canada.
          </p>

          <div className="flex gap-4 flex-wrap justify-center md:justify-start">
            <div className="inline-flex text-white bg-emerald-600 hover:bg-emerald-500 border-0 py-2.5 px-6 focus:outline-none rounded-lg text-sm font-medium transition-colors cursor-pointer">
              <DownloadButton />
            </div>
            <a
              href="#contact"
              className="inline-flex text-gray-300 bg-gray-800 border border-gray-700 hover:bg-gray-700 hover:text-white py-2.5 px-6 focus:outline-none rounded-lg text-sm font-medium transition-colors"
            >
              Work With Me
            </a>
          </div>
        </div>

        <div className="flex-shrink-0">
          <UserProfileFlip frontImageUrl={avatar} backImageUrl={profile_picture} />
        </div>
      </div>
    </section>
  );
}

export default About;
